import { render, staticRenderFns } from "./UserCreatePassword.vue?vue&type=template&id=30144838&"
import script from "./UserCreatePassword.vue?vue&type=script&lang=js&"
export * from "./UserCreatePassword.vue?vue&type=script&lang=js&"
import style0 from "./UserCreatePassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports